import React, { useEffect, useState } from "react";
import { ExternalLink, Maximize2, Lock, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";

export default function MapEmbed({ appellation, height = 540 }) {
  const { t } = useT();
  const [token, setToken] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancel = false;
    api.get("/geovinum-token")
      .then((r) => { if (!cancel) setToken(r.data.token); })
      .catch(() => { if (!cancel) setError(true); });
    return () => { cancel = true; };
  }, []);

  if (error) {
    return (
      <div className="relative w-full rounded-3xl overflow-hidden border border-[#1F3A5F]/10 bg-[#F7F2EE] p-12 text-center" style={{ minHeight: height }}>
        <div className="w-12 h-12 mx-auto rounded-full bg-[#FCE4ED] flex items-center justify-center mb-4">
          <Lock className="w-5 h-5 text-[#E5276A]" />
        </div>
        <p className="text-base text-[#1F3A5F] font-light max-w-md mx-auto leading-relaxed">{t("map.unavailable")}</p>
        <Link to={`/pro?app=${encodeURIComponent(appellation)}`} className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-[#E5276A] hover:bg-[#C01661] text-white text-sm font-medium transition-colors">
          {t("app.detail.embed")}
        </Link>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="relative w-full rounded-3xl overflow-hidden border border-[#1F3A5F]/10 bg-[#F7F2EE] flex items-center justify-center" style={{ height }}>
        <div className="inline-flex items-center gap-2 text-sm text-[#8B95A1]">
          <Loader2 className="w-4 h-4 animate-spin" /> {t("common.loading")}
        </div>
      </div>
    );
  }

  const url = `https://iframe.geovinum.app/?token=${encodeURIComponent(token)}&app=${encodeURIComponent(appellation)}`;
  return (
    <div className="relative w-full rounded-3xl overflow-hidden border border-[#1F3A5F]/10 bg-white shadow-sm">
      <div className="absolute top-3 right-3 z-10 flex gap-2">
        <a href={url} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-white/95 backdrop-blur border border-[#1F3A5F]/10 text-[#1F3A5F] hover:bg-white hover:border-[#1F3A5F]/25 transition-colors font-medium">
          <Maximize2 className="w-3.5 h-3.5" /> {t("map.fullscreen")}
        </a>
      </div>
      <iframe
        title={`${t("map.title")} — ${appellation}`}
        src={url}
        style={{ width: "100%", height: `${height}px`, border: 0 }}
        allow="fullscreen; geolocation"
        loading="lazy"
      />
      <div className="px-5 py-3 text-xs text-[#4A5568] border-t border-[#1F3A5F]/8 flex items-center justify-between bg-[#FBF7F3]">
        <span>{t("map.title")} · <strong className="text-[#1F3A5F]">{appellation}</strong></span>
        <span className="inline-flex items-center gap-1 text-[#E5276A] font-medium">
          <ExternalLink className="w-3 h-3" /> iframe.geovinum.app
        </span>
      </div>
    </div>
  );
}
